/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Metadata_LabelInputs */

const en_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const fr_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadonnees`)
};

const de_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten`)
};

const it_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati`)
};

const ru_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные`)
};

const es_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const zh_cn2_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据`)
};

const ja_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ`)
};

const hi_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडाटा`)
};

const pt_pt2_style_guide_manager_metadata_label = /** @type {(inputs: Style_Guide_Manager_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Style_Guide_Manager_Metadata_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_metadata_label = /** @type {((inputs?: Style_Guide_Manager_Metadata_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Metadata_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_metadata_label(inputs)
	if (locale === "de") return de_style_guide_manager_metadata_label(inputs)
	if (locale === "it") return it_style_guide_manager_metadata_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_metadata_label(inputs)
	if (locale === "es") return es_style_guide_manager_metadata_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_metadata_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_metadata_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_metadata_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_metadata_label(inputs)
	return en_style_guide_manager_metadata_label(inputs)
});